import notFound from '../../assets/images/not-found.svg';
import noPermissions from '../../assets/images/no-permissions.svg';

const types = {
  noInternet: {
    img: <img src={noPermissions} height={224} loading='lazy' alt='No Internet Connection' />,
    title: '',
    message: 'No Internet Connection Found',
  },
  notFound: {
    img: <img src={notFound} height={224} loading='lazy' alt='Page Not Found' />,
    title: '',
    message: 'Oops! Page Not Found',
  },
  noPermission: {
    img: <img src={noPermissions} height={224} loading='lazy' alt='No Permissions' />,
    title: '',
    message: 'You Do Not Have The Required Permissions. Please Contact The Admin.',
  },
};

const ErrorPage = ({ type = 'notFound', error, align = 'left' }) => {
  const errorDetails = types[type] || types['notFound'];

  return (
    <div className='min-h-screen flex flex-col items-center justify-center text-center mx-auto'>
      <div className='flex justify-center items-center mb-6'>{errorDetails.img}</div>

      <h1>{errorDetails.title}</h1>

      <p className='text-gray_63 text-[14px] font-medium font-inter'>{errorDetails.message}</p>
    </div>
  );
};

export default ErrorPage;
